import {
  Grid,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  IconButton,
} from "@mui/material";
import { Card, Button } from "react-bootstrap";
import React, { useState, useContext, useEffect } from "react";
import PsContext from "../../context";
import AddIcon from "@mui/icons-material/Add";
import WidgetsIcon from "@mui/icons-material/Widgets";
import { Toast } from "antd-mobile";
import { _LIST_STAFFS } from "../../models/task";
import { Select } from "antd"; // Import Select from antd
import { _LIST_ESTABLISHMENT } from "../../models/establishment";
import AddAward from "./addAwards";
import { MuiModalWindow } from "../../utils";

const ViewEstablishment = (props) => {
  const context = useContext(PsContext);

  const [selStaff, setSelStaff] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({
    /*  postDoctoral: false,
    researchGuidance: false,
    researchProject: false, */
    awards: false,
    /*  deptExamination: false,
    achievement: false,
    countryVisit: false,
    memo: false,
    qualification: false,
    examinations: false,
    presentExp: false,
    prevExp: false,
    publication: false,
    programmesParticipated: false,
    training: false,
    transferSection: false,
    additionalIncharge: false,
    conference: false, */
  });

  const [staffs, setStaffs] = useState([]);

  const optionCodes = {
    /*  postDoctoral: "post_doctoral",
    researchGuidance: "research_guidance",
    researchProject: "research_project", */
    awards: "awards",
    /*  deptExamination: "dept_examination",
    achievement: "achievement",
    countryVisit: "country_visit",
    memo: "memo",
    qualification: "qualification",
    examinations: "examinations",
    presentExp: "present_exp",
    prevExp: "prev_exp",
    publication: "publication",
    programmesParticipated: "programmes_participated",
    training: "training",
    transferSection: "transfer_section",
    additionalIncharge: "additional_incharge",
    conference: "conference", */
  };

  // Handle individual checkbox change
  const handleCheckboxChange = (event) => {
    setSelectedOptions({
      ...selectedOptions,
      [event.target.name]: event.target.checked,
    });
  };

  // Handle "Check All" checkbox change
  const handleCheckAllChange = (event) => {
    const isChecked = event.target.checked;
    const newSelectedOptions = Object.keys(selectedOptions).reduce(
      (acc, key) => {
        acc[key] = isChecked;
        return acc;
      },
      {}
    );
    setSelectedOptions(newSelectedOptions);
  };
  console.log(selectedOptions);

  useEffect(() => {
    _LIST_STAFFS().then((res) => res.data && setStaffs(res.data));
  }, []);

  const handleSubmit = () => {
    // Construct the payload for selected options
    const selectedPayload = Object.keys(selectedOptions)
      .filter((key) => selectedOptions[key]) // Get only selected options
      .reduce((acc, key) => {
        acc[key] = optionCodes[key]; // Map key to its code
        return acc;
      }, {});

    // Add `staff` field directly to the payload
    if (selStaff) {
      selectedPayload.staff = selStaff;
    } else {
      Toast.show({
        icon: "fail",
        content: "Please select a staff member.",
      });
      return;
    }

    // Ensure at least one title is selected
    if (Object.keys(selectedPayload).length === 1 && !selectedPayload.staff) {
      Toast.show({
        icon: "fail",
        content: "Please select at least one title.",
      });
      return;
    }

    _LIST_ESTABLISHMENT(selectedPayload)
      .then((res) => {
        if (res.data.length === 0) {
          Toast.show({
            icon: "fail",
            content: res.message ? res.message : "No Data",
          });
        }
      })
      .catch((error) => {
        console.error("Error listing tasks:", error);
        Toast.show({
          icon: "fail",
          content: "No Data.",
        });
      });
  };

  return (
    <>
      <Card>
        <Card.Header className="card-header-bg fw-bold text-uppercase">
          {context.allowedAccess(
            "mob_allow_estblishment_approval",
            "action_update"
          )
            ? "VIEW ESTABLISHMENT"
            : "MY PROFILE"}

          <span className="float-end p-0 m-0">
            {context.allowedAccess(
              "mob_allow_estblishment_approval",
              "action_update"
            ) && (
              <IconButton
                color="primary"
                onClick={props.goBackToDashboard}
                aria-label="go-to-dashboard"
                className="p-0 m-0 me-2"
              >
                <WidgetsIcon />
              </IconButton>
            )}
            <IconButton
              color="primary"
              onClick={() => setShowModal(true)}
              aria-label="add-new"
              className="p-0 m-0"
            >
              <AddIcon />
            </IconButton>
          </span>
        </Card.Header>

        <Card.Body className="mt-2">
          {/* Staff Dropdown with antd Select */}
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Select
                  id="staff-select"
                  value={selStaff}
                  onChange={(value) => setSelStaff(value)}
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Select Staff"
                  style={{ width: "100%" }}
                  allowClear
                >
                  {staffs.map((staff) => (
                    <Select.Option key={staff.id} value={staff.id}>
                      {staff.employee_name}
                    </Select.Option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Check All Checkbox */}
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Object.values(selectedOptions).every((val) => val)}
                    onChange={handleCheckAllChange}
                    color="primary"
                  />
                }
                label="Check All"
              />
            </Grid>
          </Grid>

          {/* Checkbox for Titles inside colorful cards */}
          <Grid container spacing={2} mt={2}>
            {Object.keys(selectedOptions).map((key) => (
              <Grid item xs={12} key={key}>
                <Card style={{ backgroundColor: "#f0f0f0", padding: "10px" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedOptions[key]}
                        onChange={handleCheckboxChange}
                        name={key}
                        color="primary"
                      />
                    }
                    label={optionCodes[key].replace(/_/g, " ").toUpperCase()}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Submit and Reset Buttons */}
          <Grid container spacing={2} mt={2} alignItems="flex-end">
            <Grid item xs={3}>
              <Button
                variant="contained"
                className="bg-theme text-white"
                fullWidth
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Grid>

            <Grid item xs={3}>
              <Button
                variant="outlined"
                className="bg-theme text-white"
                fullWidth
                onClick={() => {
                  setSelectedOptions(
                    Object.keys(selectedOptions).reduce((acc, key) => {
                      acc[key] = false;
                      return acc;
                    }, {})
                  );
                  setSelStaff(""); // Reset the staff selection
                }}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </Card.Body>
      </Card>
      <MuiModalWindow
        open={showModal}
        onClose={(e) => setShowModal(false)}
        title="Add Awards"
      >
        <AddAward
          onSuccess={(e) => {
            setShowModal(false);
          }}
        />
      </MuiModalWindow>
    </>
  );
};

export default ViewEstablishment;
